/**
 * Checks if the given value is undefined.
 *
 * @param value - The value to check.
 * @returns Whether the value is undefined.
 */
export const isUndef = (value: unknown) => typeof value === "undefined"
